import { Component, OnInit } from '@angular/core';
import { configuracion } from '../../recursos/config.service'
import { EjecutarScript } from '../../recursos/EjecutarScript.service';

@Component({
  selector: 'app-body-public',
  templateUrl: './body-public.component.html',
  styleUrls: ['./body-public.component.css']

})
export class BodyPublicComponent implements OnInit {
  isLoading = true;
  constructor(private cargaJS: configuracion) { }

  ngOnInit() {
    this.cargaJS.cargarScriptInicio();
    this.OpenMenu();
  }
  OpenMenu() {
    setTimeout(() => {
      this.isLoading = false;
    }, 2200);
  }
}